import React, { useEffect, useState } from "react";
import {
  collection,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { NewUserProfileType } from "../Types/userProfile";
import AIToolsInformation from "./AIToolsInformation";
import { app } from "../lib/firebase";
import "../lib/RequireUser/index.css";

const db = getFirestore(app);

var user2: any;
var uid: any;

var bodyStyles = document.body.style;

const tempUser = localStorage.getItem("userUID");
console.log("inside UserProfile 1 and local storage for userID = ", tempUser);
//document.querySelector(':root').style.setProperty("--user"), localStorage.getItem("userUID"));

//const userUID = bodyStyles.getPropertyValue("--user");
//console.log("inside UserProfile 1 and user id from root = ", userUID);

function AIToolsPre() {
  const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  const q = query(
    collection(db, "userProfiles"),
    where("userUID", "==", tempUser)
  );

  useEffect(
    () =>
      onSnapshot(q, (snapshot) => {
        setUserProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  return (
    <div>
      {userProfiles && userProfiles.length ? (
        <div>
          {userProfiles?.map((userProfiles) => (
            <AIToolsInformation
              key={userProfiles.id}
              userProfile={userProfiles}
            />
          ))}
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default AIToolsPre;
